$(document).ready(function(){

    $("#pagination-select").on('change', function(){
        value = $(this).val();
        window.top.location = value;
    });

    AOS.init({
        duration: 1000,
    });


    /*
	Advanced Filtering by Tony

	This function works on the principles that:
		1. There can be multiple groups of filters
		2. But all filter groups assign classes to the items in the same way
		3. And each filter group has a default / reset of (*)
		4. And that when nothing is set in that group, then * must be active
		5. So when * is active for that group, nothing else can be set in that group
		6. And finally, the actual filtering ignores *
    */
	$("#searchFiltersGroup button, #searchFiltersMobileGroup .btn").click(function(e)
    {
        e.preventDefault(); // don't move or link the element
        var vals = []; // array of currently selected tags / attributes, always starts empty
        var currentElement = $(this); // just clicked
        var currentGroup = $(this).data("tag-group"); // the group we are working with
        var currentValue = $(this).data("value"); // the value we are working with



        /* 
        	STEP 1: RESET ACTIVES
			Toggle currentElement's "active" state
			Then:
			A If currentElement is now active
				A1 If it's the default (*), then remove all other actives for this group
				A2 Else make sure the default (*) is not active in this group
			B Else
				B1 See if there are any active elements within this group
				B2 If not, then make the default (*) active
        */

        /*currentElement.toggleClass("active"); // change active status
        if (currentElement.hasClass("active"))
        {
        	if (currentElement.data("value") == "*")
        	{
        		$('[data-tag-group]').each(function ()
        		{
        			if ($(this).data("tag-group") == currentGroup && $(this).data("value") != currentValue )
        			{
        				$(this).removeClass("active"); 	
        			}
        		});
        	}
        	else
        	{
        		$('[data-tag-group]').each(function ()
        		{
        			if ($(this).data("tag-group") == currentGroup && $(this).data("value") == "*" )
        			{
        				$(this).removeClass("active"); 	
        			}
        		});
        	}
        }
        else
        {
        	var activeCount = 0;
    		$('[data-tag-group]').each(function ()
    		{
    			if ($(this).hasClass("active"))
    			{
    				activeCount++;
    			}
    		});
    		if (activeCount < 1)
    		{
         		$('[data-tag-group]').each(function ()
        		{
        			if ($(this).data("tag-group") == currentGroup && $(this).data("value") == "*" )
        			{
        				$(this).addClass("active"); 	
        			}
        		});   			
    		}
        }*/


        currentElement.toggleClass("active"); // change active status
        if (currentElement.hasClass("active"))
        {
            $('[data-tag-group]').each(function()
            {
                if ($(this).data("tag-group") == currentGroup)
                {
                    $(this).removeClass("active");  
                }
            });
            currentElement.addClass("active");
        }
        else
        {
            var activeCount = 0;
            $('[data-tag-group]').each(function ()
            {
                if ($(this).data("tag-group") == currentGroup)
                {
                    $(this).removeClass("active");
                    if ($(this).data("value") == "*")
                    {
                        $(this).addClass("active");  
                    }
                }
            });
        }

        /*
			STEP 2: All Actives
			As we now have a list of Active Toggles (across all groups), we can turn them into an array
        */

 		$('[data-tag-group]').each(function ()
		{
			if ($(this).hasClass("active") && $(this).data("value") != "*" )
			{
				vals.push($(this).data("value"));	
			}
		});  

        //console.log(vals);


        /*
			STEP 3: Only show those that match
        */

        // only proceed if at least one tag is selected
        if (vals.length > 0)
        {   
            var now_showing = 0;
            $('.product_collection .product').each( function(i) // for each listing row
            {   
                var matches_required = vals.length; // easier to set this now for comparison
                var current_matches = 0;
                var v_tags = $(this).data('tags').split(','); // convert this data attribute into an array

                v_tags.forEach( function(entry) // for each item in this arrray, 
                {
                    var entry2 = entry.trim(); // trim it
                    if (vals.indexOf(entry2) > -1) //if there's a match in the tags selected array
                    {
                        current_matches++; // add 1
                    }
                });
                if (current_matches == matches_required)// if we have an exact match, then remove hide 
                { 
                    $(this).slideDown();
                    now_showing++;
                }
                else // else add hide
                {
                    $(this).slideUp();   
                }
            });

            // adjust the result count and set the no-results msg
            var count_info = "Items: " + now_showing;
            //console.log(count_info);

            $("#results-count").html(count_info);
            $('#no-results-msg').slideUp();

            if (now_showing == 0)
            {
                $('#no-results-msg').slideDown();
            }

        }
        else
        {
        	var tally = 0;
            $('.product_collection .product').each( function(i)
            {
            	tally++;
                $(this).slideDown();
            });   
            var count_info = "Items: " + tally;
            $("#results-count").html(count_info);
            $('#no-results-msg').slideUp();

            if (now_showing == 0)
            {
                $('#no-results-msg').slideDown();
            }
            
        }

    } );

    // lightbox
    $(document).on('click', '[data-toggle="lightbox"]', function(event) 
    {
      event.preventDefault();
      $(this).ekkoLightbox();
    });


});
